import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeVideoComponent } from './home-video/home-video.component';
import { FormVideoComponent } from './form-video/form-video.component';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';




@NgModule({
  declarations: [
    HomeVideoComponent,
    FormVideoComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
  ]
})
export class BlockVideoModule { }
